import { render } from "./AgentAccess.vue?vue&type=template&id=594e2ef4&scoped=true"
import script from "./AgentAccess.vue?vue&type=script&lang=js"
export * from "./AgentAccess.vue?vue&type=script&lang=js"

import "./AgentAccess.vue?vue&type=style&index=0&id=594e2ef4&scoped=true&lang=scss"

import exportComponent from "/var/www/html/chatbot_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594e2ef4"]])

export default __exports__